<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "DiscountCodes",
};
</script>

<style scoped></style>
